import React, { useMemo } from 'react';
import {
    Col,
    Form,
    FormControl,
    InputGroup,
    Row,
    Spinner,
    Table
} from 'react-bootstrap';
import EmailConfigViewmodel from './EmailConfig.viewmodel';
import { useAdminCompanies } from '../../../hooks';

export default function EmailConfig() {
    const { isLoading, emailConfigs } = EmailConfigViewmodel();

    console.log(emailConfigs?.map(e => [e.sid, e.wftype, e.wfcondition]));

    const { adminCompanies, isAllowedAllCompanies } = useAdminCompanies();

    const filteredEmailConfigs = useMemo(
        () =>
            emailConfigs?.filter(
                emailConfig =>
                    isAllowedAllCompanies ||
                    adminCompanies?.some(
                        adminCompany => adminCompany.sid === emailConfig.sid
                    )
            ),
        [isAllowedAllCompanies, adminCompanies, emailConfigs]
    );

    return (
        <div>
            <div className="master-data-content">
                <div
                    className="trapezoid-head"
                    style={{ width: '200px' }}
                >
                    <span>Email Config</span>
                </div>

                <div className="mat-box">
                    <Row>
                        <Col>
                            <div className="container">
                                <div
                                    className="trapezoid trapezoid-purple"
                                    style={{
                                        display: 'inline-block',
                                        width: 'fit-content'
                                    }}
                                >
                                    <span>
                                        <i
                                            className="fa fa-search"
                                            aria-hidden="true"
                                        ></i>
                                        Email Config
                                    </span>
                                </div>
                                {/*<div*/}
                                {/*    style={{*/}
                                {/*        display: 'inline-block',*/}
                                {/*        float: 'right'*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    <Button*/}
                                {/*        className="mx-2"*/}
                                {/*        variant="outline-info"*/}
                                {/*        size="sm"*/}
                                {/*        onClick={() => {*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        <FaPlusCircle/>*/}
                                {/*        &nbsp;Save*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                                <div className="divide-y border-x">
                                    <div className="flex bg-neutral-200">
                                        <div className="flex-1 py-1.5 text-center font-semibold">
                                            Config
                                        </div>
                                        <div className="flex-[2] py-1.5 text-center font-semibold">
                                            Content
                                        </div>
                                    </div>
                                    {emailConfigs?.map((emailConfig, index) => (
                                        <div
                                            key={index}
                                            className="flex gap-4 p-4"
                                        >
                                            <div className="flex-1">
                                                <div className="flex w-full flex-col gap-1">
                                                    <InputGroup>
                                                        <Form.Group
                                                            className="w-full"
                                                            controlId="formBasicEmail"
                                                        >
                                                            <Form.Label>
                                                                SID :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="sid"
                                                                value={
                                                                    emailConfig.sid
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                WF TYPE :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="wftype"
                                                                value={
                                                                    emailConfig.wftype
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                WF CONDITION :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="wfcondition"
                                                                value={
                                                                    emailConfig.wfcondition
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                Email CC :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="emailcc"
                                                                value={
                                                                    emailConfig.emailcc
                                                                }
                                                                readOnly
                                                            />

                                                            <Form.Label className="mt-3">
                                                                Email BCC :
                                                            </Form.Label>
                                                            <FormControl
                                                                className="w-full"
                                                                placeholder="emailbcc"
                                                                value={
                                                                    emailConfig.emailbcc
                                                                }
                                                                readOnly
                                                            />
                                                        </Form.Group>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                            <div className="flex-[2]">
                                                <div className="flex w-full flex-col">
                                                    <Form.Label className="">
                                                        Subject :
                                                    </Form.Label>
                                                    <div
                                                        className="form-control hover:none prose w-full max-w-none bg-[#e9ecef] px-4 text-sm"
                                                        dangerouslySetInnerHTML={{
                                                            __html: emailConfig.contentsubject
                                                        }}
                                                    />
                                                    <Form.Label className="mt-3">
                                                        Body :
                                                    </Form.Label>
                                                    <div
                                                        className="prose w-full max-w-none text-sm"
                                                        dangerouslySetInnerHTML={{
                                                            __html: emailConfig.contentbody
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}
